import React from 'react';
import './FoundUsersTable.css';

export default function FoundUsersTableRow({found_user, send_invite}) 
{     
    var phone_email;

    if ((found_user.MobilePhoneNumber) && (found_user.MobilePhoneNumber.length > 0))
        phone_email = found_user.MobilePhoneNumber;

    if ((found_user.EmailAddress) && (found_user.EmailAddress.length > 0)) {
        if ((phone_email) && (phone_email.length > 0))
            phone_email = phone_email + ' ' + found_user.EmailAddress;
        else
            phone_email = found_user.EmailAddress; 
    }
    
    const send_invite_for_found_user = () => {    
        if (!found_user) return;

        send_invite(found_user);
    }

    return (
        <>
            <tr class="found-user-row">
                <th>{found_user.UserFullName}</th>
                <td>{found_user.UserName}</td>
                <td>{phone_email}</td>
                <td>
                    <a href="#"><img src="./images/request.svg" alt="invite" border="0" onClick={send_invite_for_found_user}/></a>
                </td>
            </tr>
        </>
    );
}